import React from 'react';
import { Badge, Group, Text } from '@mantine/core';
import { IconTrophy } from '@tabler/icons-react';

interface MVPBadgeProps {
    playerName: string;
    mvpScore: number;
    variant?: 'match' | 'team';
}

export const MVPBadge: React.FC<MVPBadgeProps> = ({ playerName, mvpScore, variant = 'match' }) => {
    return (
        <Badge
            size="lg"
            color="yellow"
            variant="filled"
            leftSection={<IconTrophy size={14} />}
            styles={{ root: { textTransform: 'none' } }}
        >
            <Group gap={4}>
                <Text fw={600}>{playerName}</Text>
                {variant === 'match' && (
                    <Text size="xs" c="dark.2">({mvpScore.toFixed(1)})</Text>
                )}
            </Group>
        </Badge>
    );
};






